// src/components/LogoScroller.js

import React from 'react';

// Logo imports
import amazonLogo from '../assets/images_scroll/amazon.svg';
import azurLogo from '../assets/images_scroll/Azur.svg';
import ethLogo from '../assets/images_scroll/Eth.svg';
import gmailLogo from '../assets/images_scroll/Gmail.svg';
import mysqlLogo from '../assets/images_scroll/MYSQL.svg';
import oracleLogo from '../assets/images_scroll/oracle.svg';
import polkaLogo from '../assets/images_scroll/Polka.svg';
import postgresqlLogo from '../assets/images_scroll/PostgreSQL.svg';
import salesforceLogo from '../assets/images_scroll/SalesForce.svg';
import sapLogo from '../assets/images_scroll/SAP.svg';
import stripLogo from '../assets/images_scroll/Strip.svg';
import temenosLogo from '../assets/images_scroll/temenos.svg';
import tradtrustLogo from '../assets/images_scroll/TradTrust.svg';
import uniLogo from '../assets/images_scroll/UNI.svg';

const logos = [
  { src: amazonLogo, alt: 'Amazon' },
  { src: azurLogo, alt: 'Azur' },
  { src: tradtrustLogo, alt: 'TradTrust' },
  { src: ethLogo, alt: 'Ethereum' },
  { src: stripLogo, alt: 'Stripe' },
  { src: mysqlLogo, alt: 'MySQL' },
  { src: oracleLogo, alt: 'Oracle' },
  { src: polkaLogo, alt: 'Polkadot' },
  { src: postgresqlLogo, alt: 'PostgreSQL' },
  { src: salesforceLogo, alt: 'Salesforce' },
  { src: sapLogo, alt: 'SAP' },
  { src: gmailLogo, alt: 'Gmail' },
  { src: temenosLogo, alt: 'Temenos' },
  { src: tradtrustLogo, alt: 'TradTrust' },
  { src: uniLogo, alt: 'Uniswap' },
];


const LogoScroller = () => {
  return (
    <div className="bg-black py-12 sm:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-y-10 sm:gap-y-12">

        {/* Responsive Title Section */}
        <div className="w-full text-center sm:text-left">
          <h3 className="text-xl sm:text-2xl font-semibold text-white">
            Connectors we support in Universal Adapter
          </h3>
        </div>

        {/* Scroller Section */}
        <div className="w-full">
          <div className="group w-full">
            <div
              className="w-full inline-flex flex-nowrap overflow-hidden 
                         [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-200px),transparent_100%)]"
            >
              <div
                className="flex items-center justify-center md:justify-start animate-scroll 
                           group-hover:[animation-play-state:paused] gap-x-12 sm:gap-x-16"
              >
                {/* Render the first set of logos */}
                {logos.map((logo, index) => (
                  <div key={`logo-${index}`} className="flex-shrink-0">
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className="h-10 sm:h-12 lg:h-16 w-auto transition-all duration-300 ease-in-out grayscale opacity-70 hover:grayscale-0 hover:opacity-100 hover:scale-110"
                    />
                  </div>
                ))}

                {/* Render the duplicated set for the infinite effect */}
                {logos.map((logo, index) => (
                  <div key={`logo-duplicate-${index}`} className="flex-shrink-0" aria-hidden="true">
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className="h-10 sm:h-12 lg:h-16 w-auto transition-all duration-300 ease-in-out grayscale opacity-70 hover:grayscale-0 hover:opacity-100 hover:scale-110"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default LogoScroller;